import { render } from "./close.vue?vue&type=template&id=793431ef"
const script = {}
script.render = render

export default script